<template>
  <div class="main">
    <floorMapAside
    @clickMerchant="clickMerchant"
    @reloadFloorMap="reloadFloorMap"
    :width="asideW"></floorMapAside>
    <optAside @changeAsideW="changeAsideW" :width="asideW"></optAside>
    <div id="mapBox" class="map-box" :style="{'left': asideW + 'px'}">
      <settledTell></settledTell>
      <project ref="project" :pW="pW" :pH="pH"></project>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {commonMixin} from '@/mixins/commonMixin'
import project from '@/components/project'
import floorMapAside from '@/components/floorMapAside'
import settledTell from '@/components/settledTell'
import optAside from '@/components/optAside'
export default {
  name: 'FloorMap',
  mixins: [commonMixin],
  components: {
    project,
    floorMapAside,
    settledTell,
    optAside
  },
  data () {
    return {
      asideW: 350,
      pW: '',
      pH: ''
    }
  },
  created () {
    const that = this
    // 一进入此页面首先重置stroe相关的state
    that.resetStore()
    
    const merchantId = that.$route.query.merchantId || ''
    const cityId = that.$route.query.cityId || ''
    const projectId = that.$route.query.projectId || ''
    that.$store.commit('setMerchantId', merchantId)
    that.$store.commit('setCityId', cityId)
    that.$store.commit('setProjectId', projectId)
  },
  mounted () {
    const that = this
    const $mapBox = $('#mapBox')
    that.pW = $mapBox.width()
    that.pH = $mapBox.height()
  },
  methods: {
    changeAsideW (e) {
      this.asideW = e
    },
    clickMerchant () {
      this.$refs.project.clickMerchant()
    },
    reloadFloorMap () {
      this.$refs.project.init()
    }
  }
}
</script>

<style scoped>
.main{position: fixed;left: 0;right: 0;bottom: 0;top: 0;background-color: #D8D8D6;}
.map-box{position: absolute;left: 350px;top: 0;right: 0;bottom: 0;overflow: hidden;}
</style>